module.exports = __webpack_public_path__ + "static/img/z3.28726ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/z3.png
// module id = ENaa
// module chunks = 1